module.exports = __webpack_public_path__ + "img/index_detail.8d12b018.svg";